module.exports = __webpack_public_path__ + "img/3.2a8c9d73.png";